(function () {
  'use strict';

  var STORAGE_KEY = 'libroReclamacionesLastSubmission';

  var form = document.getElementById('libro-reclamaciones-form');

  if (form) {
    var minorToggle = form.querySelector('[id^="checkbox-is-minor-"]');
    var minorFields = document.getElementById('rc-minor-fields');

    if (minorToggle && minorFields) {
      var minorInputs = minorFields.querySelectorAll('input');

      var syncMinorFields = function () {
        var isMinor = minorToggle.checked;
        minorFields.hidden = !isMinor;

        for (var i = 0; i < minorInputs.length; i++) {
          minorInputs[i].disabled = !isMinor;
          minorInputs[i].required = isMinor;
          if (!isMinor) minorInputs[i].value = '';
        }
      };

      minorToggle.addEventListener('change', syncMinorFields);
      syncMinorFields();
    }

    var submitButton = form.querySelector('button[type="submit"]');
    var submitHint = form.querySelector('.rc-submit-hint');

    if (submitButton) {
      var updateSubmitState = function () {
        var isValid = form.checkValidity();
        submitButton.disabled = !isValid;
        if (submitHint) submitHint.hidden = isValid;
      };

      form.addEventListener('input', updateSubmitState);
      form.addEventListener('change', updateSubmitState);
      updateSubmitState();

      // Coming back to the page from the browser history (bfcache) restores the button as the submit handler left it
      // (disabled and busy), so it is reset here.
      window.addEventListener('pageshow', function () {
        submitButton.removeAttribute('aria-busy');
        updateSubmitState();
      });
    }

    form.addEventListener('submit', function () {
      var now = new Date();
      var rand = Math.random().toString(36).slice(2, 8).toUpperCase();
      var code = 'RC-' + now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate()) + '-' + rand;

      var codeField = document.getElementById('rc-code');
      var dateField = document.getElementById('rc-datetime');

      if (codeField) codeField.value = code;
      if (dateField) dateField.value = formatLimaDate(now);

      var typeField = form.querySelector('[name="contact[Tipo de solicitud]"]');

      try {
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            code: code,
            type: typeField ? typeField.value : '',
            date: now.toISOString()
          })
        );
      } catch (error) {
        // sessionStorage unavailable (private browsing, storage disabled, etc.)
        // — the confirmation panel falls back to a generic message instead.
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
    });
  }

  var confirmation = document.getElementById('rc-confirmation');

  if (confirmation) {
    var codeEl = confirmation.querySelector('[data-rc-code]');
    var typeEl = confirmation.querySelector('[data-rc-type]');
    var dateEl = confirmation.querySelector('[data-rc-date]');
    var fallbackEl = confirmation.querySelector('[data-rc-fallback]');
    var raw = null;

    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      raw = null;
    }

    var parsed = null;

    if (raw) {
      try {
        parsed = JSON.parse(raw);
      } catch (error) {
        parsed = null;
      }
    }

    if (parsed) {
      if (codeEl) codeEl.textContent = parsed.code;
      if (typeEl) typeEl.textContent = parsed.type;
      if (dateEl) dateEl.textContent = new Date(parsed.date).toLocaleString();
    } else if (fallbackEl) {
      fallbackEl.hidden = false;
    }

    var printButton = confirmation.querySelector('[data-rc-print]');

    if (printButton) {
      printButton.addEventListener('click', function () {
        document.body.classList.add('rc-printing');
        window.print();
      });

      window.addEventListener('afterprint', function () {
        document.body.classList.remove('rc-printing');
      });
    }
  }

  // Always-visible print button: prints the whole section (it borrows the .rc-print-area rules in libro-reclamaciones.css for the
  // duration of the print dialog, so the header, footer and the rest of the page stay out of the paper).
  function initPagePrint() {
    var button = document.querySelector('.rc-print-page');
    var section = document.querySelector('[data-rc-section]');

    if (!button || !section) return;

    button.addEventListener('click', function () {
      section.classList.add('rc-print-area');
      document.body.classList.add('rc-printing');
      window.print();
    });

    window.addEventListener('afterprint', function () {
      section.classList.remove('rc-print-area');
      document.body.classList.remove('rc-printing');
    });
  }

  initPagePrint();

  // The registration time is stored in Peruvian time (the store's market), not in the visitor's own timezone or UTC.
  function formatLimaDate(date) {
    try {
      return date.toLocaleString('es-PE', { timeZone: 'America/Lima', hour12: false }) + ' (hora de Lima)';
    } catch (error) {
      return date.toISOString();
    }
  }

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }
})();
